// @ts-nocheck
/**
 * Audio preview dialog — inline player for uploaded IVR node audio.
 */
import ReactAudioPlayer from 'react-audio-player';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const AudioPreviewModal = ({
  show,
  onClose,
  audioUrl,
  title = 'Audio Preview',
  autoPlay = true,
}: any) => {
  if (!audioUrl) return null;

  const cleanTitle = title.replace(/\.[^/.]+$/, '');

  return (
    <Dialog open={!!show} onOpenChange={(next) => !next && onClose?.()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{cleanTitle}</DialogTitle>
        </DialogHeader>
        <ReactAudioPlayer
          key={audioUrl}
          src={audioUrl}
          controls
          autoPlay={autoPlay}
          style={{ width: '100%' }}
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AudioPreviewModal;
